import {
    BaseScoreResult,
    QuestionnaireResponse,
    Item,
    findItemByLinkId,
    getAnswerCode
} from './types';

const SCORE_EXTENSION_URL = "http://hl7.org/fhir/StructureDefinition/questionnaire-optionScore";

export type MoriskyAdherenceLevel =
    | 'muito_baixa'
    | 'baixa'
    | 'moderada'
    | 'alta'
    | 'excelente';

export interface MoriskyScoreResult extends BaseScoreResult {
    totalScore: number;
    adherenceLevel: MoriskyAdherenceLevel;
    details: Record<string, number>;
}

function getItemScoreFromOption(item: Item | undefined): number {
    if (!item) return 0;
    const code = getAnswerCode(item);
    if (code === undefined) return 0;

    const selectedOption = item.answerOption?.find(opt => opt.valueCoding?.code === code);
    const scoreExtension = selectedOption?.extension?.find(ext => ext.url === SCORE_EXTENSION_URL);
    const score = scoreExtension?.valueInteger ?? parseInt(code, 10);
    return Number.isFinite(score) ? score : 0;
}

export function getMoriskyAdherenceLevel(totalScore: number): MoriskyAdherenceLevel {
    if (totalScore <= 7) return 'muito_baixa';
    if (totalScore <= 11) return 'baixa';
    if (totalScore <= 14) return 'moderada';
    if (totalScore <= 17) return 'alta';
    return 'excelente';
}

const MORISKY_ITEM_LINK_IDS = ['morisky_1', 'morisky_2', 'morisky_3', 'morisky_4'] as const;

export function processMoriskyQuestionnaire(response: QuestionnaireResponse): MoriskyScoreResult {
    const rootItems = response.item || [];

    const details: Record<string, number> = {};
    let totalScore = 0;

    MORISKY_ITEM_LINK_IDS.forEach(linkId => {
        const item = findItemByLinkId(rootItems, linkId);
        const score = getItemScoreFromOption(item);
        details[linkId] = score;
        totalScore += score;
    });

    const adherenceLevel = getMoriskyAdherenceLevel(totalScore);

    return {
        questionnaireId: response.questionnaire?.split('/')?.[1],
        questionnaireResponseId: response.id,
        totalScore,
        adherenceLevel,
        details
    };
}
